var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErrorAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2402 4.60074C12.1006 4.46716 11.8996 4.46716 11.7599 4.60074C9.37276 6.88417 5.48172 11.9236 3.80413 17.4787C3.74289 17.6814 3.83812 17.8468 3.97633 17.9081C5.53739 18.6018 8.43582 19.5006 12.0001 19.5006C15.5643 19.5006 18.4628 18.6018 20.0238 17.9081C20.162 17.8468 20.2573 17.6814 20.196 17.4787C18.5184 11.9236 14.6274 6.88417 12.2402 4.60074ZM10.5256 3.31032C11.3556 2.51635 12.6445 2.51635 13.4746 3.31032C16.0203 5.7454 20.1164 11.0382 21.9055 16.9624C22.209 17.9674 21.7655 19.0883 20.749 19.54C18.9945 20.3197 15.8497 21.2863 12.0001 21.2863C8.15043 21.2863 5.0056 20.3197 3.25117 19.54C2.23468 19.0883 1.79117 17.9674 2.09466 16.9624C3.88375 11.0382 7.97989 5.7454 10.5256 3.31032ZM12.0001 7.40793C12.5918 7.40793 13.0715 7.88761 13.0715 8.47936V12.8752C13.0715 13.467 12.5918 13.9467 12.0001 13.9467C11.4083 13.9467 10.9286 13.467 10.9286 12.8752V8.47936C10.9286 7.88761 11.4083 7.40793 12.0001 7.40793ZM13.0757 16.1925C13.0757 15.6008 12.596 15.1211 12.0043 15.1211C11.4125 15.1211 10.9328 15.6008 10.9328 16.1925V16.7718C10.9328 17.3636 11.4125 17.8433 12.0043 17.8433C12.596 17.8433 13.0757 17.3636 13.0757 16.7718V16.1925Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorAlert);
export default __webpack_public_path__ + "static/media/Error-Alert.2bb5b399.svg";
export { ForwardRef as ReactComponent };